import { useState } from "react";
import { reviews } from "@/mocks/site";

export default function FeaturedReviews() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="featured" className="w-full border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Editor&apos;s Notes</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">精选解读</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            从已收录的合集里挑出三部，分别聊聊它们的结构、套路和情绪落点，帮你决定先点开哪一部。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {reviews.map((review) => {
            const isOpen = openId === review.id;
            return (
              <article
                key={review.id}
                className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <div className="relative h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={review.image}
                    alt={`${review.drama} 剧情场景示意图`}
                    title={`${review.drama} 精选解读配图`}
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent" />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-movie-line text-xs" aria-hidden="true" />
                    </span>
                    {review.drama}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <span className="text-xs text-foreground-500">{review.meta}</span>
                  <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">
                    {review.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">{review.lead}</p>

                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "mt-3 grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="text-sm leading-relaxed text-foreground-600">{review.body}</p>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : review.id)}
                    aria-expanded={isOpen}
                    className="mt-4 inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
                  >
                    {isOpen ? "收起" : "展开全文"}
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true" />
                    </span>
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}